<div class="login-page jhm-page" [class.mobile]="screenSize==='MOBILE'">
  <div class="logo-and-name">
    <img class="logo" src="./assets/images/bird.svg">
    <div class="name">
      <img class="jail" src="./assets/images/jail.svg">
      <img class="house" src="./assets/images/house.svg">
      <img class="mail" src="./assets/images/mail.svg">
    </div>
  </div>

  <!-- Initial -->
  @if (initialState && !showLogin && !forgotPassword && !passwordReset && !changePassword && !loginMessage && !confirmationSuccessful) {
    <div class="login-box">
      <div class="ls-box-header">
        <div class="title">Welcome to Jailhouse Mail!</div>
        <p>Please select your action.</p>
      </div>
      <div class="ls-box-body">
        <div class="form-section">
          <div class="form-item">
            <div class="input-title login-button-title">New Users</div>
            <p>New to Jailhouse Mail? Click here to register as a new user.</p>
            <button class="jhm-button primary fill" [routerLink]="['/sign-up']">Register</button>
          </div>
        </div>
        <hr class="form-divider" />
        <div class="form-section">
          <div class="form-item">
            <div class="input-title login-button-title">Existing Users</div>
            <p>Already have an account? Click here to go to the log in screen or reset your current password.</p>
            <button data-pw="go-to-login-button" class="jhm-button primary fill" (click)="showLogin = true; initialState = false">Go To Log in</button>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Log in -->
  @if ((confirmationSuccessful || loginMessage || (!initialState && showLogin)) && !forgotPassword && !passwordReset && !changePassword) {
    <div class="login-box">
      @if (!confirmationSuccessful) {
        <div class="ls-box-header">
          <div class="title">Civilian - Log In</div>
          <p>Welcome back! Please enter your details below.</p>
        </div>
      }
      @if (confirmationSuccessful) {
        <div class="ls-box-header">
          <div class="title">Civilian - Registration Successful</div>
          <p>You have successfully confirmed your email and can now login!</p>
        </div>
      }
      <div class="ls-box-body">
        @if (warningMessage) {
          <div class="notice error">
            <i class="fa-solid fa-hexagon-exclamation notice-lead"></i>
            {{warningMessage}}
            <button class="jhm-icon-button transparent"><i class="fa-regular fa-times" (click)="warningMessage = null"></i></button>
          </div>
        }
        @if (!warningMessage && loginMessage) {
          <div class="notice">
            <i class="fa-solid fa-hexagon-exclamation notice-lead"></i>
            {{loginMessage}}
            <button class="jhm-icon-button transparent"><i class="fa-regular fa-times" (click)="loginMessage = null"></i></button>
          </div>
        }
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Email</div>
            <mat-form-field appearance="outline">
              <input data-pw="login-email" matInput [(ngModel)]="username" id="username" name="username" placeholder="Email">
            </mat-form-field>
          </div>
        </div>
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Password</div>
            <div class="fp-link"><a class="forgot-password" (click)="forgotPassword = true; showLogin = false; initialState = false">Forgot your password?</a></div>
            <mat-form-field appearance="outline">
              <input data-pw="login-password" matInput type="password" [(ngModel)]="password" id="password" name="password" placeholder="Password">
            </mat-form-field>
          </div>
        </div>
        <hr class="form-divider" />
      </div>
      <div class="ls-box-footer">
        <div class="form-section">
          <div class="form-item">
            <button data-pw="login-btn" class="jhm-button primary" (click)="login()">Log in</button>
          </div>
        </div>
		<div class="form-section">
			<div class="form-item">Don't have an account? <a [routerLink]="['/sign-up']">Sign Up</a>.</div>
			<!-- <div class="form-item reset-pin">Have a reset pin? <a (click)="changePassword = true">Reset Password</a>.</div> -->
		</div>
      </div>
    </div>
  }

  <!-- Forgot Password -->
  @if (!initialState && !showLogin && forgotPassword && !passwordReset && !changePassword) {
    <div class="login-box">
      <button class="jhm-icon-button transparent ls-box-back" (click)="forgotPassword = false; showLogin=true"><i class="fa-regular fa-arrow-left"></i></button>
      <div class="ls-box-header">
        <div class="title">Forgot Your Password</div>
        <p>Enter your email address below and we'll send you a password reset link.</p>
      </div>
      <div class="ls-box-body">
        @if (warningMessage) {
          <div class="notice error">
            <i class="fa-solid fa-hexagon-exclamation notice-lead"></i>
            {{warningMessage}}
            <button class="jhm-icon-button transparent"><i class="fa-regular fa-times" (click)="warningMessage = null"></i></button>
          </div>
        }
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Email</div>
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="username" id="username" name="username" placeholder="Email">
            </mat-form-field>
          </div>
        </div>
        <hr class="form-divider" />
      </div>
      <div class="ls-box-footer">
        <div class="form-section">
          <div class="form-item">
            <button class="jhm-button primary" (click)="sendResetEmail()">Send Reset Email</button>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Forgot Password Link -->
  @if (!initialState && !showLogin  && !forgotPassword && passwordReset && !changePassword) {
    <div class="login-box">
      <img class="back" (click)="passwordReset = false; showLogin = true" src="./assets/images/arrow-left.svg">
      <div class="ls-box-header">
        <div class="title">Check Your Email</div>
        <p>If your email is in our system, you should have received a link to reset your password.</p>
      </div>
      <div class="ls-box-footer">
        <div class="form-section">
          <div class="form-item">
            <button class="jhm-button primary" (click)="passwordReset = false; showLogin = true">Return to Login</button>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Update Password -->
  @if (!initialState && !showLogin  && !forgotPassword && !passwordReset && changePassword) {
    <div class="login-box">
      <img class="back" (click)="changePassword = false; passwordsDontMatch = false; showLogin = true" src="./assets/images/arrow-left.svg">
      <div class="ls-box-header">
        <div class="title">Update Your Password</div>
        <p>Please type your new password twice below to update it.</p>
      </div>
      <div class="ls-box-body">
        @if (passwordsDontMatch) {
          <div class="notice error">
            <i class="fa-solid fa-hexagon-exclamation notice-lead"></i>
            Please check your passwords to make sure they match.
            <button class="jhm-icon-button transparent"><i class="fa-regular fa-times" (click)="warningMessage = null"></i></button>
          </div>
        }
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Password</div>
            <mat-form-field appearance="outline">
              <input type="password" matInput [(ngModel)]="newPassword" id="new-password" name="new-password" placeholder="Password" (keydown)="checkConfirmedPassword()">
            </mat-form-field>
          </div>
        </div>
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Confirm Password</div>
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="newConfirmedPassword" id="new-confirmed-password" name="new-confirmed-password" placeholder="Confirm Password" (keydown)="checkConfirmedPassword()">
            </mat-form-field>
          </div>
        </div>
        <hr class="form-divider" />
      </div>
      <div class="ls-box-footer">
        <div class="form-section">
          <div class="form-item">
            <button class="jhm-button primary" [class.disabled]="passwordsDontMatch || !newPassword || !newConfirmedPassword" (click)="updatePassword()">Update Password</button>
          </div>
        </div>
      </div>
    </div>
  }
</div>